import React from 'react'

function RangeInput() {
  return (
    <div>RangeInput</div>
  )
}

export default RangeInput